import React from 'react';

import { Box, FormControl } from '@rbilabs/universal-components';
import { FieldProps } from 'formik';
import { TouchableWithoutFeedback } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import { TextInputProps } from 'components/ucl/text-input/types';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { getDesignToken, spacing } from 'styles/constants';

type FormikMaskInputType = {
  onPress: () => void;
  placeholder: string;
};

export const FormikMaskInput = React.forwardRef<
  HTMLInputElement,
  FieldProps<string, { [key: string]: string }> & TextInputProps & FormikMaskInputType
>(({ form, field, ...props }, _ref) => {
  const { errors, touched } = form;
  const { placeholder, value, label } = props;
  const errorMessage = errors?.[field.name];
  const fieldTouched = touched?.[field.name];
  const showErrors = fieldTouched && errorMessage;

  const handleOnPress = () => {
    form.setFieldTouched(field.name, true);
    props.onPress();
  };

  useLogUserErrorMessage({
    message: errorMessage,
    logWhenTrue: fieldTouched && !!showErrors && !!errorMessage,
    severity: LogUserErrorSeverity.Unknown,
    context: {
      fieldName: field?.name,
      label,
    },
  });

  return (
    <TouchableWithoutFeedback onPress={handleOnPress}>
      <FormControl isInvalid={!!errorMessage} margin="0">
        <Box margin="2">
          {label && <FormControl.Label>{label}</FormControl.Label>}
          <Box
            borderWidth={1}
            borderColor={getDesignToken('border-color-input')}
            minHeight="$8"
            padding={spacing.$2_5}
            backgroundColor="white"
            borderRadius={4}
          >
            <Typography>{value || placeholder}</Typography>
          </Box>
          {showErrors && errorMessage && (
            <FormControl.ErrorMessage margin="0" p="0">
              {errorMessage}
            </FormControl.ErrorMessage>
          )}
        </Box>
      </FormControl>
    </TouchableWithoutFeedback>
  );
});
